"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bufferToCSV = void 0;
/**
 * Returns csv file from a array buffer
 * @param {Buffer}            value      - value to format
 *
 * @return csv file url
 */
var bufferToCSV = function (value) {
    var file = new Blob([value], { type: 'application/csv' });
    var url = URL.createObjectURL(file);
    return url;
};
exports.bufferToCSV = bufferToCSV;
